import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f220642"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "namespace-team-page"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"0 0.5rem"} }, "Продолжить", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"padding":"0 0.688rem"} }, "Отменить", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "namespace-team-page__title" }, "Команда", -1))
const _hoisted_5 = { class: "namespace-team-page__content" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "namespace-team-page__users-list" }
const _hoisted_9 = { class: "namespace-team-page__user-item-left" }
const _hoisted_10 = { class: "namespace-team-page__sign-name" }
const _hoisted_11 = { class: "namespace-team-page__user-item-right" }
const _hoisted_12 = {
  key: 0,
  style: {"margin-top":"5rem"}
}

import { ref, onMounted, computed, inject, ComputedRef } from "vue";
import { NamespaceQueuesAdapterService } from "./adapter";
import { SaveTeamModel, UserModel } from "./models";
import {
  TirPmButton,
  TirPmButtonVariantEnum,
  TirPmButtonSizeEnum,
  TirPmIconView,
  TirPmNotificationEventBus,
  TirPmNotificationModel,
  TirPmModal,
} from "tir-components";
import { TirPmSearchInput, TirPmSearchInputContentLine } from "tir-pm-search-input";
import { CurrentUser, UserRoleEnum } from "tir-pm-user-core";
import { ListBulletIcon, TrashIcon, UserIcon } from "tir-style-system/icons/outline";
import TirPmSystemMessage from "tir-pm-system-message/src/tir-pm-system-message.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'namespace-team-page',
  props: {
  /**ID неймспейса */
  namespaceId: {
    type: String,
    required: true,
  },
  /**ID проекта */
  projectId: {
    type: Number,
    required: true
  }
},
  setup(__props) {

const props = __props;



const adapter = new NamespaceQueuesAdapterService();
/**Владелец */
const isOwner = computed(() => !!CurrentUser.Roles.includes(UserRoleEnum.Owner));
/**Админ проекта */
const isAdminProject = inject("isAdminProject") as ComputedRef<boolean>;
/**Админ неймспейса */
const isAdminNamespace = inject("isAdminNamespace") as ComputedRef<boolean>;

/**Загузка */
const isLoading = ref(false);
/**Список идентификаторов сохраненных в команде пользователей в виде строки */
const lastTeamIdsStr = ref("");
/**Список идентификаторов команды */
const teamIds = ref(new Array<number>());
/**Список команды */
const getTeam = async () => {
  const resp = await adapter.getTeam(props.namespaceId);
  if (resp.IsSuccess) {
    teamIds.value = resp.Value.map((user) => user.Id);
    lastTeamIdsStr.value = JSON.stringify(teamIds.value);
  }
};

const teamUserItem = ref();

const searchQueryUsers = ref<string>(null);

/**Сохранить модалку редактирования */
const saveModalEditEmployee = async () => {
  const resp = await adapter.saveTeam(
    new SaveTeamModel({
      NamespaceId: props.namespaceId,
      UserIds: selectedTeamUsers.value.map((x) => x.Id),
      RemoveQueueTasksAccess: true,
      RemoveTaskObserver: true,
      RemoveTaskPerformer: true,
    }),
  );

  if (resp.IsSuccess) {
    await getTeam();
    TirPmNotificationEventBus.emit(
      "add",
      new TirPmNotificationModel({
        title: "Успешное редактирование",
        type: "success",
        group: "general",
        life: 5000,
        closable: true,
        callbackButton: () => {},
      }),
    );
  } else {
    TirPmNotificationEventBus.emit(
      "add",
      new TirPmNotificationModel({
        title: resp.ErrorMessage ?? "Произошла ошибка",
        type: "error",
        group: "general",
        life: 5000,
        closable: true,
        callbackButton: () => {},
      }),
    );
  }
};

const copiedEditData = ref();
const isVisible = ref(false);

// Переменная для списка пользователей, чтобы назначить из него админом или участником для селекта
const UserList = ref<Array<UserModel>>([]);

const selectedTeamUsers = ref<Array<UserModel>>([]);
const copiComparedUserList = ref<Array<UserModel>>([]);

/**Сортировка команду юзеров по имени */
const sortTeam = computed(() =>
  selectedTeamUsers.value.sort((a, b) => a.FirstName.localeCompare(b.FirstName)),
);

// Функция для фильтрации юзеров
const filteredUser = (selectedUserName?: UserModel & string) => {
  copiComparedUserList.value = UserList.value;
  copiComparedUserList.value = copiComparedUserList.value.filter(
    (x) => !selectedTeamUsers.value.find((y) => y.Id == x.Id),
  );
  copiComparedUserList.value.sort((a, b) => a.FirstName.localeCompare(b.FirstName));
  if (typeof selectedUserName == "string" && selectedUserName.length) {
    copiComparedUserList.value = copiComparedUserList.value.filter((x) => {
      let compairedString = x?.FirstName + " " + x?.MiddleName + " " + x?.LastName;
      return compairedString.toLowerCase().includes(selectedUserName.toLowerCase());
    });
  }
};

const onMouseDown = (user: UserModel, event: MouseEvent) => {
  if(user.IsProjectAdmin || user.IsNamespaceAdmin) event.preventDefault();
}

// Функция для выбора юзера для селекта команда
const setTeamToNamespace = (selectedUser: UserModel) => {
  if(selectedUser.IsProjectAdmin || selectedUser.IsNamespaceAdmin) return;
  
  selectedTeamUsers.value.push(selectedUser);

  filteredUser();
  saveModalEditEmployee();
  searchQueryUsers.value = "";
};

// Функция для удаления юзера для селекта команда
const removeTeamForNamespace = (removedAdmin: UserModel) => {
  selectedTeamUsers.value = selectedTeamUsers.value.filter((x) => x.Id !== removedAdmin.Id);
  filteredUser();
  saveModalEditEmployee();

  isVisible.value = false;
};

const loadProjects = async () => {
  let resp = await adapter.getEmployees(props.projectId, props.namespaceId);

  UserList.value = resp.Value.map(
    (x) =>
      new UserModel({
        Id: x.Id,
        FirstName: x.FirstName,
        LastName: x.LastName,
        MiddleName: x.MiddleName,
        Photo: x.Photo,
        AvatarColor: x.AvatarColor,
        IsNamespaceAdmin: x.IsNamespaceAdmin,
        IsProjectAdmin: x.IsProjectAdmin
      }),
  );
  copiComparedUserList.value = UserList.value;
  filteredUser();
};

onMounted(async () => {
  try {
    copiedEditData.value = (await adapter.getTeam(props.namespaceId)).Value;
    selectedTeamUsers.value = copiedEditData.value;
    await loadProjects();
  } catch {}
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (!isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_unref(TirPmModal), {
            "is-visible": isVisible.value,
            title: "Доступ к тикетам всех очередей будет аннулирован",
            "is-with-back": false,
            onClose: _cache[2] || (_cache[2] = ($event: any) => (isVisible.value = false))
          }, {
            content: _withCtx(() => [
              _createTextVNode(" Тикеты, наблюдаемые и назначенные в работу, станут недоступны ")
            ]),
            footer: _withCtx(() => [
              _createVNode(_unref(TirPmButton), {
                size: _unref(TirPmButtonSizeEnum).Regular,
                variant: _unref(TirPmButtonVariantEnum).PrimaryState,
                onClick: _cache[0] || (_cache[0] = ($event: any) => (removeTeamForNamespace(teamUserItem.value)))
              }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              }, 8, ["size", "variant"]),
              _createVNode(_unref(TirPmButton), {
                size: _unref(TirPmButtonSizeEnum).Regular,
                variant: _unref(TirPmButtonVariantEnum).LinkState,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (isVisible.value = false))
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["size", "variant"])
            ]),
            _: 1
          }, 8, ["is-visible"]),
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_unref(TirPmSearchInput), {
              style: {"width":"100%"},
              label: "Команда",
              placeholder: "",
              isWithPopup: true,
              modelValue: searchQueryUsers.value,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchQueryUsers).value = $event)),
              onInput: filteredUser,
              isDisabled: !isOwner.value && !_unref(isAdminProject) && !_unref(isAdminNamespace)
            }, {
              content: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(copiComparedUserList.value, (user) => {
                  return (_openBlock(), _createBlock(_unref(TirPmSearchInputContentLine), {
                    "is-disabled": user.IsProjectAdmin || user.IsNamespaceAdmin,
                    key: user.Id,
                    onMousedown: ($event: any) => (onMouseDown(user, $event)),
                    onClick: _withModifiers(($event: any) => (setTeamToNamespace(user)), ["stop"])
                  }, {
                    leftSlot: _withCtx(() => [
                      _createVNode(_unref(TirPmIconView), {
                        size: 24,
                        isRounded: "",
                        isBordered: false,
                        colorCode: user.AvatarColor,
                        imageLoadUrl: user.Photo
                      }, {
                        mainSlot: _withCtx(() => [
                          _createTextVNode(_toDisplayString(user?.FirstName?.[0].toUpperCase()) + _toDisplayString(user?.LastName?.[0].toUpperCase()), 1)
                        ]),
                        _: 2
                      }, 1032, ["colorCode", "imageLoadUrl"])
                    ]),
                    rightSlot: _withCtx(() => []),
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(user.FirstName) + " " + _toDisplayString(user.MiddleName) + " " + _toDisplayString(user.LastName), 1),
                      (user.IsProjectAdmin)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, " (Администратор проекта)"))
                        : (user.IsNamespaceAdmin)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_7, " (Администратор раб. области)"))
                          : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["is-disabled", "onMousedown", "onClick"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue", "isDisabled"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortTeam.value, (teamUser) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "namespace-team-page__user-item",
                key: teamUser.Id
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_unref(TirPmIconView), {
                    size: 48,
                    isRounded: "",
                    isBordered: false,
                    colorCode: teamUser.AvatarColor,
                    imageLoadUrl: teamUser.Photo
                  }, {
                    mainSlot: _withCtx(() => [
                      _createTextVNode(_toDisplayString(teamUser?.FirstName?.[0].toUpperCase()) + _toDisplayString(teamUser?.LastName?.[0].toUpperCase()), 1)
                    ]),
                    _: 2
                  }, 1032, ["colorCode", "imageLoadUrl"]),
                  _createElementVNode("div", _hoisted_10, _toDisplayString(teamUser?.FirstName) + " " + _toDisplayString(teamUser?.MiddleName) + " " + _toDisplayString(teamUser?.LastName), 1)
                ]),
                _createElementVNode("div", _hoisted_11, [
                  (isOwner.value || _unref(isAdminProject))
                    ? (_openBlock(), _createBlock(_unref(TirPmButton), {
                        key: 0,
                        size: _unref(TirPmButtonSizeEnum).Small,
                        variant: _unref(TirPmButtonVariantEnum).LinkState,
                        onClick: ($event: any) => ((isVisible.value = true), (teamUserItem.value = teamUser))
                      }, {
                        leftSlot: _withCtx(() => [
                          _createVNode(_unref(TrashIcon))
                        ]),
                        _: 2
                      }, 1032, ["size", "variant", "onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            }), 128)),
            (sortTeam.value.length == 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(TirPmSystemMessage, null, {
                    topDescImage: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_unref(TirPmIconView), { style: {"width":"5rem","height":"5rem"} }, {
                          mainSlot: _withCtx(() => [
                            _createVNode(_unref(UserIcon), { style: {"width":"3.5rem","height":"3.5rem","color":"var(--neutral-70, #686c73)"} })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    mainTitleSlot: _withCtx(() => [
                      _createTextVNode(" Добавьте сотрудников в команду рабочей области ")
                    ]),
                    actionsSlot: _withCtx(() => []),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})